import { AggregateScoreType } from "~/operations";
import { CheckCell, CheckCellProps } from "./CheckCell";
import { AdvisoryCell, AdvisoryCellProps } from "./AdvisoryCell";
import { VulnerabilityCell, VulnerabilityCellProps } from "./VulnerabilityCell";

type Props = {
  type: AggregateScoreType;
  checkCellProps: CheckCellProps;
  advisoryCellProps: AdvisoryCellProps;
  vulnerabilityCellProps: VulnerabilityCellProps;
};

export function TopActionFindingCell({
  type,
  checkCellProps,
  advisoryCellProps,
  vulnerabilityCellProps,
}: Props) {
  switch (type) {
    case AggregateScoreType.Check:
      return <CheckCell {...checkCellProps} />;
    case AggregateScoreType.Advisory:
      const title = advisoryCellProps.row.findingMrn.split("/").pop() || "";
      return <AdvisoryCell {...advisoryCellProps} title={title} />;
    case AggregateScoreType.Vulnerability:
      return <VulnerabilityCell {...vulnerabilityCellProps} />;
    default:
      return <></>;
  }
}
